import {
  hasPushPermissions,
  requestPushPermissions,
  verifyServiceWorkerExistence,
} from 'dashboard/helper/pushHelper';
import responsivenessMixin from 'dashboard/mixins/zimobi/responsivenessMixin';

export default {
  mixins: [responsivenessMixin],
  data() {
    return {
      hasEnabledPushPermissions: false,
    };
  },
  computed: {
    shouldRequestPushPermissions() {
      return !this.hasEnabledPushPermissions && this.isAtMobile;
    },
  },
  mounted() {
    this.hasEnabledPushPermissions = false;
    if (hasPushPermissions()) {
      this.getPushSubscription();
    }

    if (this.shouldRequestPushPermissions) {
      this.onRequestPermissions();
    }
  },
  methods: {
    onRegistrationSuccess() {
      this.hasEnabledPushPermissions = true;
    },
    onRequestPermissions() {
      requestPushPermissions({
        onSuccess: this.onRegistrationSuccess,
      });
    },
    getPushSubscription() {
      verifyServiceWorkerExistence(registration =>
        registration.pushManager
          .getSubscription()
          .then(subscription => {
            if (!subscription) {
              this.hasEnabledPushPermissions = false;
            } else {
              this.hasEnabledPushPermissions = true;
            }
          })
          // eslint-disable-next-line no-console
          .catch(error => console.log(error))
      );
    },
  },
};
